import {StoreObject, Store} from "stem-core/src/state/Store";
import {field} from "./misc/StoreField";
import {apiConnection} from "../connection/BlinkApiConnection";
import {EditableObjectStatus} from "./misc/GenericEnums";


export class Merchant extends StoreObject {
    @field("Currency") currency;
    @field(String) name;
    @field(String) alias;
    @field(Date) createdAt;
    @field(String) url;
    @field(String) wideLogoUrl;

    @field(Boolean) isFake;
    @field(Boolean) isNonprofit;

    @field(Boolean) autoPay;
    @field(Boolean) allowEmailing;
    @field(Boolean) allowPurchases;
    @field(Boolean) allowSubscriptions;
    @field(Boolean) allowDonations;
    @field(Boolean) allowUnverifiedEmailUsers;

    @field("LegalEntity") legalEntity;

    @field(EditableObjectStatus) sdkStatus;

    getUrl() {
        return this.url;
    }

    getName() {
        return this.name;
    }

    getCurrency() {
        return this.currency;
    }

    isAutopayCompatible() {
        return this.autoPay === true;
    }

    toString() {
        return this.name;
    }

    hasPurchasesEnabled() {
        return !!this.allowPurchases;
    }

    hasSubscriptionsEnabled() {
        return !!this.allowSubscriptions;
    }

    hasSubscriptionDiscountCodeEnabled() {
        return !!this.hasSubscriptionDiscountCode;
    }

    hasDonationsEnabled() {
        return !!this.allowDonations;
    }
}

class MerchantStoreClass extends Store("Merchant", Merchant) {
    getAutopayCompatibleMerchants() {
        return this.all().filter(merchant => merchant.isAutopayCompatible());
    }

    getByIdOrAlias(key) {
        const entry = this.get(key);
        if (entry) {
            return entry;
        }
        return this.all().find(merchant => merchant.alias === key);
    }

    getByMerchantUserId(id) {
        return this.all().find(merchant => merchant.userId === id);
    }
}


export const MerchantStore = new MerchantStoreClass();

export async function apiMerchantEditSDKStatus(request) {
    return apiConnection.post("/merchant/edit_sdk_status/", request);
}
